import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '../shared/helpers/utils';
import { Constants } from '../shared/helpers/constants';

import { ApiService } from '../shared/services/api.service';
import { CartService } from '../shared/services/cart.service';
import { PageAccessService } from '../shared/services/page-access.service';

import { Company, Pcategory, Product, Dmenu } from '../shared/models';

import { environment } from '../../environments/environment';

import * as smoothscroll from 'smoothscroll-polyfill';
import { DomSanitizer } from '@angular/platform-browser';

import { faUtensils } from '../icons';

@Component({
    selector: 'app-digital-menus',
    templateUrl: './digital-menus.component.html',
    styleUrls: ['./digital-menus.component.scss'],
    standalone: false
})
export class DigitalMenusComponent implements OnInit {
  company: Company;
  dmenus: Dmenu[] = [];
  pcategories: Pcategory[];

  availableLangs: {
    abrev: string,
    flagUrl: string,
    selected: boolean,
    initial: boolean
  }[] = [{
    abrev: 'pt',
    flagUrl: '/assets/images/flags/flag-br.webp',
    selected: true,
    initial: true
  }];

  done: boolean = false;
  // The master refused the page (plan's monthly visits, or late payment): what the customer reads.
  blockedMessage: string | null = null;

  logoPath: string;
  serverUrl: string = environment.server_url;

  disclaimers: string[] = ['*valores sujeitos a alteração sem prévio aviso'];

  selectedDmenu: Dmenu;
  showPrice: boolean = true;
  selectedProduct: Product = <Product>{id: null, picture_path: {url: null}};
  modalImagePath: string;
  modalImageElement: Element;

  scrollY: number;
  pcategoriesOffset: {el: HTMLElement, offset: number}[] = [];
  scrolling: boolean = false;
  customStyle: any;

  private _pcatsDone: number = 0;
  private _pcatsTotal: number;

  faUtensils = faUtensils;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private api: ApiService,
              private sanitizer: DomSanitizer,
              private cart: CartService,
              private pageAccess: PageAccessService) { }

  ngOnInit(): void {
    smoothscroll.polyfill();
  	this.route.paramMap.subscribe(
  		res => {
  			if(res["params"] && res["params"].company_name) {
          this.logoPath = '/assets/companies-logo/' + res["params"].company_name + ".webp";
          const name = res["params"].company_name;
          const dmenuId = res["params"].dmenu_id;
          this.pageAccess.check(name, 'menu').subscribe(blocked => {
            this.blockedMessage = blocked;
            if (blocked) {
              this.done = true;
            } else {
              this._loadCompany(name, dmenuId);
            }
          });
  			} else {
  				alert("Não foi possível obter o menu do estabelecimento");
  			}
  		}
  	);
    this.modalImageElement = document.getElementById('imageModal');
  }

  ngAfterViewInit() {
    this._setOffsetTimeout();
  }
  private _setOffsetTimeout() {
    setTimeout(() => {
      if(this.done && (this.dmenus.length == 0 || this.selectedDmenu)) {
        let els = document.getElementsByClassName("pcategory-container");
        for(let i = 0; i < els.length; i++) {
          let el: HTMLElement = <HTMLElement>els[i];
          this.pcategoriesOffset.push({el: el, offset: el.offsetTop - 50});
        }
      } else {
        this._setOffsetTimeout();
      }
    }, 100);
  }

  pageScroll(scrollY) {
    this.scrollY = scrollY;

    if(this.pcategoriesOffset.length == 0 || this.scrolling)
      return;
    
    this._setActiveBadge();
  }

  scrollToPcategory(pcategory: Pcategory, index: number) {
    this.scrolling = true;
    let el = document.getElementsByClassName("pcategory-container")[index];
    el.scrollIntoView({behavior: 'smooth'});
  }

  stoppedScrolling() {
    this.scrolling = false;
    this._setActiveBadge();
  }

  showImage(event, product: Product) {
    event.preventDefault();

    this.selectedProduct = product;
  }
  closeProduct() {
    this.selectedProduct = null;
  }

  goToDmenu(dmenu_id: number) {
    this.router.navigate([dmenu_id.toString()], {relativeTo: this.route});
  }
  selectDmenu(dmenu_id: number) {
    this.api.show('dmenus', dmenu_id).subscribe(
      res => {
        // Check if the selected dmenu_id belongs to the company
        if(res.dmenu.company_name && res.dmenu.company_name != this.company.name) {
          alert(`O menu '${res.dmenu.name}' (${res.dmenu.id}) não pertence à empresa '${this.company.name}'`);
          return;
        }

        Pcategory.setArrayAdditionalData(res.dmenu.pcategories);
        let visiblePcategories = [];
        for(let pcat of res.dmenu.pcategories) {
          if(pcat.isOnSchedule) {
            visiblePcategories.push(pcat);
          }
        }

        this.pcategories = visiblePcategories;

        this._pcatsTotal = this.pcategories.length;
        this._pcatsDone = 0;

        Dmenu.setAdditionalData(res.dmenu);
        res.dmenu.pcategories = Pcategory.sortByDisplayOrder(visiblePcategories, 'digital_menu');

        let langs = Pcategory.availableLangs(visiblePcategories);
        for(let lang of langs) {
          this.availableLangs.push({
            abrev: lang,
            flagUrl: '/assets/images/flags/' + Constants.flagIcons[lang],
            selected: false,
            initial: false
          })
        }

        this.selectedDmenu = res.dmenu;
        if(this.selectedDmenu.parsedOrder.prices == false)
          this.showPrice = false;

        for(let pcat of this.pcategories) {
          this._loadProducts(pcat);
        }
        window.scroll(0, 0);
      },
      err => {
        console.log(err);
        alert(`Erro ao abrir o cardápio`);
      }
    );
  }

  selectLanguage(language: {abrev: string, flagUrl: string, selected: boolean, initial: boolean}) {
    for(let lang of this.availableLangs) {
      lang.selected = false;
      if(language.abrev == lang.abrev)
        lang.selected = true;
    }

    let abrev = language.initial ? null : language.abrev;

    Dmenu.translate(this.dmenus, abrev);
    Pcategory.translate(this.pcategories, abrev);
    if(this.pcategories) {
      for(let pcat of this.pcategories) {
        Product.translate(pcat.products, abrev);
      }
    }
    localStorage.setItem('preferred_lang', JSON.stringify(language));
  }
  loadPreferredLanguage() {
    let langStr = localStorage.getItem('preferred_lang');
    if(langStr) {
      this.selectLanguage(JSON.parse(langStr));
    }
  }

  private _loadCompany(company_name: string, dmenu_id: number = null) {
    this.api.show('companies', company_name).subscribe(
      res => {
        this.customStyle = this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/digital-menus/${res.company.name}.css`);
        this.company = res.company;

        // fetch disclaimers
        let disclaimers = Company.getDigitalMenuDisclaimers(this.company);
        if(disclaimers) {
          this.disclaimers = disclaimers;
        }

        // get dmenu data
        if(dmenu_id) {
          this.selectDmenu(dmenu_id);
        } else {
          Dmenu.setArrayAdditionalData(res.company.dmenus);
          this.dmenus = Dmenu.sortByDisplayOrder(res.company.dmenus, 'digital_menu');
          
          if(this.dmenus.length > 0) {
            // get translation info
            let langs = Dmenu.availableLangs(this.dmenus);
            for(let lang of langs) {
              this.availableLangs.push({
                abrev: lang,
                flagUrl: '/assets/images/flags/' + Constants.flagIcons[lang],
                selected: false,
                initial: false
              });
            }
            this.loadPreferredLanguage();

            this.done = true;
          } else {
            this._loadPcategories(this.company.id);
          }
        }
      },
      err => {
        console.log(err);
        alert("Erro ao obter informações do restaurante");
      }
    );
  }
  private _loadPcategories(company_id: number) {
    this.api.indexAll('pcategories', {
      q: {
        company_id: company_id,
        hidden: false,
        digital_menu: true
      }
    }).subscribe(
      res => {
        Pcategory.setArrayAdditionalData(res.pcategories, 'on_site');
        let visiblePcategories = [];
        for(let pcat of res.pcategories) {
          if(pcat.isOnSchedule) {
            visiblePcategories.push(pcat);
          }
        }

        this.pcategories = Pcategory.sortByDisplayOrder(visiblePcategories, 'digital_menu');
        let langs = Pcategory.availableLangs(visiblePcategories);
        for(let lang of langs) {
          this.availableLangs.push({
            abrev: lang,
            flagUrl: '/assets/images/flags/' + Constants.flagIcons[lang],
            selected: false,
            initial: false
          })
        }
        this.loadPreferredLanguage();
        this._pcatsTotal = visiblePcategories.length;
        for(let pcat of visiblePcategories) {
          this._loadProducts(pcat);
        }
      },
      err => {
        console.log(err);
        alert("Erro ao obter os produtos do restaurante");
      }
    );
  }
a
  private _loadProducts(pcategory) {
    this.api.indexAll('products', {
      q: {
        pcategory_id: pcategory.id,
        hidden: false,
        digital_menu: true
      }
    }).subscribe(
      res => {
        Product.setArrayAdditionalData(res.products, 'on_site');
        res.products = Pcategory.orderProducts(pcategory, res.products);
        if(res.products.length == 0) {
          this.pcategories.splice(this.pcategories.indexOf(pcategory), 1);
        }
        pcategory.products = res.products;
        this._pcatsDone++;

        if(this._pcatsDone == this._pcatsTotal) {
          this.loadPreferredLanguage();
          this.done = true;
        }
      }
    );
  }

  private _setActiveBadge(index = null) {
    if(this.pcategoriesOffset.length == 0) {
      return;
    }
    
    if(index == null) {
      for(let i = this.pcategories.length - 1; i >= 0 ; i--) {
        if(this.scrollY > this.pcategoriesOffset[i].offset) {
          index = i;
          break;
        }
      }
    }

    this._setActiveBadgeByIndex(index);
    this._scrollIntoPcategoriesList(index);
  }
  private _setActiveBadgeByIndex(index) {
    for(let i = this.pcategories.length - 1; i >= 0 ; i--) {
      if(i == index)
        this.pcategories[i].is_active = true;
      else
        this.pcategories[i].is_active = false;
    }
  }
  private _scrollIntoPcategoriesList(index) {
    let el: HTMLElement = <HTMLElement>document.getElementsByClassName("pcategory-badge")[index];
    if(el)
      el.parentElement.scroll(el.offsetLeft - 100, 0);
  }
}
